import fetch from "services/FetchInterceptor";
import axios from "axios";

const AuthService = {};

AuthService.login = async function (data, endpoint) {
    try {
        const response = await axios.post(endpoint, data);
        return response; // You can return the response data if needed
    } catch (error) {
        console.log("Error:", error);
    }
};

AuthService.logout = function () {
    return fetch({
        url: "/auth/logout",
        method: "post",
    });
};

AuthService.loginInOAuth = function () {
    return fetch({
        url: "/auth/loginInOAuth",
        method: "post",
    });
};

export default AuthService;
